import { call, takeEvery } from 'redux-saga/effects';
import { sendSMSRequest } from '../../requests/send_sms_request';
import { message_error, message_success } from '../../../../../components/Message';

function* sendSMS({ template_id, lead_id }) {
    const { result, error } = yield call(sendSMSRequest, template_id, lead_id);
    result ? message_success('SMS sent successfully!') : message_error(error && (error.message || error.msg));
}

export default function* sendSMSSaga() {
    yield takeEvery('SEND_SMS_REQUEST', sendSMS);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/send_sms_saga.js